export const DTONOMY_SUPPORT_EMAIL = "support@dtonomy.com";
export const USER_PREFERENCE_STORAGE_KEY_PREFIX = "UserPreferences_";
export const USER_PREFERENCE_REPORT_PHISHING_EMAIL_PROP = "reportPhishingToEmail";
export const USER_PREFERENCE_SHOW_ANALYSIS_PROP = "showMoreAnalysis";